import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { add_theme_category, update_theme_category } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';

import './themecategoriesform.css';

export const ThemeCategoriesForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData } = useContext(NewContext);
    const [themeCategories, setThemeCategories] = useState({
        name: state ? state.name : "",
        priority: state ? state.priority : "",
        isActive: state ? state.isActive == undefined ? false : state.isActive : false,
    });
    const [imgObj, setImgObj] = useState({ iconImgTheme: state ? state.iconImg : "" });

    const capitalizeFirstLetter = (str) => {
        let strAry = str.split(" ");
        let strCapitalized = strAry.map(_str => _str.charAt(0).toUpperCase() + _str.slice(1));
        return strCapitalized.join(" ");
    }
    const handleChange = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: e.target.name === 'name' ? capitalizeFirstLetter(e.target.value) : e.target.value });
        setThemeCategories({ ...themeCategories, [e.target.name]: e.target.name === 'name' ? capitalizeFirstLetter(e.target.value) : e.target.value });
    };

    const handleFileInput = (e) => {
        if (e.target.files[0].size > 5242880) {
            toast.error(`${e.target.name.charAt(0).toUpperCase() + e.target.name.slice(1)} must less than 5 MB!`);
        } else {
            setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
            setUpdatedData({ ...updatedData, [e.target.name]: e.target.files[0] });
            setThemeCategories({ ...themeCategories, [e.target.name]: e.target.files[0] });
        }
    };

    let handleSwitch = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: themeCategories[e.target.name] ? false : true });
        setThemeCategories({ ...themeCategories, [e.target.name]: themeCategories[e.target.name] ? false : true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        };
        let createUpdateCategories;
        setIsLoading(true);
        if (state) {
            createUpdateCategories = await update_theme_category(updatedData, state._id)
        } else {
            createUpdateCategories = await add_theme_category(themeCategories)
        }
        setIsLoading(false);
        if (createUpdateCategories) {
            const { message, status } = createUpdateCategories;
            if (status) {
                toast.success(message);
                navigate("/themecategories");
                setThemeCategories({
                    name: "",
                    priority: "",
                    isActive: false,
                });
                setImgObj({ iconImgTheme: "" });
                setUpdatedData({});
                setValidated(false);
            } else {
                toast.error(message);
            };
        }

        // var allFieldDone = [];

        // Object.keys(themeCategories).map(async (fieldName, i) => {
        //     if (fieldName !== 'id') {
        //         if (themeCategories[fieldName].toString().length > 0) {
        //             allFieldDone.push(true);
        //         } else {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //         }
        //     }
        // });

        // const aalFieldDone = allFieldDone.every((val, i, arr) => val === true)
        // if (aalFieldDone) {
        //     let createUpdateCategories;
        //     setIsLoading(true);
        //     if (state) {
        //         createUpdateCategories = await update_theme_category(themeCategories, state._id)
        //     } else {
        //         createUpdateCategories = await add_theme_category(themeCategories)
        //     }
        //     setIsLoading(false);
        //     if (createUpdateCategories) {
        //         const { message, status } = createUpdateCategories;
        //         if (status) {
        //             toast.success(message);
        //             navigate("/themecategories");
        //             setThemeCategories({
        //                 id: "",
        //                 name: "",
        //                 priority: "",
        //                 isActive: false,
        //             });
        //             setImgObj({ iconImgTheme: "" });
        //         } else {
        //             toast.error(message);
        //         };
        //     }
        // }
    };

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit Theme Categories` : `Add Theme Categories`}</h3>
            </div>
            <Row>
                <Col lg={3} md={4} sm={6} className="mb-3 mx-auto">
                    <Row className='flex-column'>
                        <Col>
                            <h6 className='mb-1'>Image Preview: </h6>
                            <img className='w-100' src={`${imgObj.iconImgTheme ? imgObj.iconImgTheme : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : themeCategories.name} />
                        </Col>
                    </Row>
                </Col>
                <Col md={8} lg={9}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='theme_categories_name' column md={3} sm={4}>Name</Form.Label>
                                    <Col><Form.Control id='theme_categories_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : themeCategories.name} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='theme_categories_priority' column md={3} sm={4}>Priority</Form.Label>
                                    <Col><Form.Control id='theme_categories_priority' type="text" placeholder="Enter priority" name='priority' onChange={handleChange} value={updatedData.priority ? updatedData.priority : themeCategories.priority} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='theme_iconImgTheme' column md={3} sm={4}>Category Image</Form.Label>
                                    <Col><Form.Control id='theme_iconImgTheme' type="file" accept='image/*' name='iconImgTheme' onChange={handleFileInput} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                    <Form.Label htmlFor='theme_categories_isActive' column md={3} sm={4}>Active</Form.Label>
                                    <Col><Form.Check type="switch" id="theme_categories_isActive" name='isActive' onChange={handleSwitch} checked={updatedData.isActive ? updatedData.isActive : themeCategories.isActive} role="button" /></Col>
                            </Col>
                        </Row>
                        <Row className='justify-content-end'>
                            <Col lg={12}>
                                <Row className='align-items-center'>
                                    <Col lg={3} md={3} sm={4}></Col>
                                    <Col>
                                        <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                                            {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                        </Button>
                                        <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

ThemeCategoriesForm.defaultProps = {
    title: "Categories Form"
};

export default ThemeCategoriesForm;